import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
  inject,
  output,
  input,
  viewChild,
} from '@angular/core';
import { translation } from '@cue/translations';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { EditableComponent, EditModeDirective, ViewModeDirective } from '@assist/ui/editable';
import { DatetimepickerComponent } from '@assist/ui/dateinputs';
import { cuePencil, IconComponent } from '@cue/ui/icons';
import { DateFormatPipe, DateTimeFormatPipe, PipesService, TimeFormatPipe } from '@cue/pipes';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'cue-datetime-info',
  templateUrl: './datetime-info.component.html',
  styleUrls: ['./datetime-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoPipe,
    DateFormatPipe,
    TimeFormatPipe,
    DatetimepickerComponent,
    EditableComponent,
    ReactiveFormsModule,
    EditModeDirective,
    ViewModeDirective,
    IconComponent,
    NgTemplateOutlet,
  ],
})
export class DatetimeInfoComponent implements OnInit {
  protected pipesService = inject(PipesService);
  public dateTimeFormatPipe = inject(DateTimeFormatPipe);
  translation = translation;
  min = input(new Date());
  edited = output<Date>();
  max = input(new Date());
  public steps: any = { hour: 1, minute: 15, second: 0 };
  dateTime = input<string | Date>();
  editable = input(false);
  editableComponent = viewChild('editable', { read: ElementRef });
  dateTimePicker = viewChild(DatetimepickerComponent);
  isStart = input<boolean>();
  type = input<'from' | 'to'>('from');

  control: FormControl<Date> = new FormControl(new Date(), { nonNullable: true });
  cuePencil = cuePencil;

  onEdit() {
    setTimeout(() => {
      this.dateTimePicker().kendoPicker.popupSettings = {
        ...this.dateTimePicker().kendoPicker.popupSettings,
        popupClass: 'editablePreventClose',
      };
      (this.dateTimePicker().kendoPicker as any).focus();
      (this.dateTimePicker().kendoPicker as any).toggle(true);
      (this.dateTimePicker().kendoPicker as any).open.next(null as any);
    }, 300);
  }

  click() {
    setTimeout(() => {
      this.editableComponent().nativeElement.click();
    }, 300);
  }

  ngOnInit() {
    this.control.valueChanges.subscribe((x) => this.edited.emit(x));
    this.control.setValue(new Date(this.dateTime()), { emitEvent: false });
  }
}
